import React from 'react'
import { twMerge } from 'tailwind-merge'

const Label = ({ children, className, ...props }) => {
  return (
    <span 
      {...props}
      className={twMerge([
        'font-medium',
        'text-gray-600',
        'text-sm',
      ], className)}
    >
      { children }
    </span>
  )
}

export default Label
